import script from "./match.vue?vue&type=script&setup=true&name=Match&lang=js"
export * from "./match.vue?vue&type=script&setup=true&name=Match&lang=js"

import "./match.vue?vue&type=style&index=0&id=63813dca&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63813dca"]])

export default __exports__